/**
 * Health-data refresh signal — a lightweight in-session broadcast so any
 * component that views health data (e.g. the Home DailyCard) can re-fetch when
 * something changes it: a FatSecret smart-sync completing, a manual metric
 * entry being saved, or a manual refresh button.
 *
 * Scope: in-memory, single browser tab only. This is NOT cross-user/device
 * (the coach's open screen won't update live — that would need server push).
 * The cross-user benefit is via persistence: the client's sync writes fresh
 * data into MC, which the coach sees on their next page load.
 */

export const HEALTH_DATA_UPDATED = 'health-data-updated';

/** Announce that health data changed; all listeners re-fetch. */
export function emitHealthDataUpdated(): void {
  window.dispatchEvent(new Event(HEALTH_DATA_UPDATED));
}

/** Subscribe to health-data changes. Returns an unsubscribe fn. */
export function onHealthDataUpdated(handler: () => void): () => void {
  window.addEventListener(HEALTH_DATA_UPDATED, handler);
  return () => window.removeEventListener(HEALTH_DATA_UPDATED, handler);
}
